<template>

    <div v-if="product != null">

        <div id="side-popup-bg" role="close-side-popup" class="fixed left-0 top-0 w-full h-full bg-black/40 z-[1001] opacity-0 pointer-events-none transition-all !duration-500" :class="show && '!opacity-100 !pointer-events-auto'" @click="closeSidePopup"></div>

        <div class="fixed left-full lg:left-[calc(100%+2rem)] top-0 h-full bg-white w-full max-w-[calc(100%-2rem)] sm:max-w-[30rem] md:max-w-[30rem] lg:max-w-[50rem] xl:max-w-[55rem] 2xl:max-w-[60rem] z-[1002] transition-all !duration-500 opacity-0 pointer-events-none" :class="show && '!-translate-x-full !opacity-100 !pointer-events-auto'">

            <div class="absolute left-0 top-0 w-[42rem] h-[23rem] pointer-events-none hidden xl:block">
                <div class="absolute top-0 left-0 w-full h-full bg-[url('/images/illustrazioni/decorazioni/piante-06.svg')] !bg-right-bottom !bg-no-repeat !bg-cover"></div>
            </div>

            <button @click="closeSidePopup" role="close-side-popup" type="button" class="absolute left-0 -translate-y-1/2 -translate-x-1/2 flex w-auto h-auto top-14 sm:top-14 md:top-16 lg:top-20 xl:top-24 2.5xl:top-28 group !rounded-full overflow-hidden shadow-xl z-[100]">
                <span class="relative w-9 h-9 sm:w-11 sm:h-11 md:w-12 md:h-12 lg:w-13 lg:h-13 rounded-full block group-hover:rotate-90 transition-all !duration-500">
                    <img alt="icona" src="/images/illustrazioni/x.svg" width="50" height="50" class="w-full h-full"/>
                </span>
            </button>

            <div class="w-full h-full flex flex-col gap-y-12 xl:gap-y-12 2.5xl:gap-y-16 relative overflow-y-scroll overflow-x-hidden px-7 py-12 sm:py-14 md:py-16 md:px-12 lg:p-20 xl:px-24 xl:py-20 2.5xl:py-24 2.5xl:px-28 lg:!pl-10 xl:!pl-10 2xl:!pl-12">

                <div class="w-full lg:h-full flex flex-col lg:flex-row items-center xl:items-start lg:gap-x-8 2xl:gap-x-10 relative --lg:overflow-hidden">

                    <div class="flex-shrink-0 pb-4 md:pb-8 lg:pb-0 lg:max-h-full lg:contents">
                        <img :alt="product.title" :src="product.image_vert" width="450" height="1140" class="h-[24rem] sm:h-[28.5rem] md:h-[35rem] lg:h-full w-auto" />
                    </div>

                    <div class="flex flex-col w-full space-y-5 sm:space-y-6 relative xl:pt-8 2xl:pt-12">
                        <div class="relative w-full h-22 xl:h-24 2.5xl:h-30 flex-shrink-0 -left-6 lg:left-0 overflow-hidden lg:overflow-visible">
                            <img alt="icona" :src="'/images/vini-orizz/scritte/' + product.category + '.svg'" width="500" height="90" class="absolute lg:-left-14 top-0 h-full w-auto max-w-screen" />
                            <div class="absolute w-2/3 lg:w-full -right-14 sm:-right-14 md:-right-16 lg:-right-20 xl:-right-24 2.5xl:-right-28 top-0 h-full bg-gradient-to-l from-white to-transparent z-10"></div>
                        </div>

                        <h2 class="text-1.5xl md:text-2.25xl lg:text-2.5xl xl:text-2.25xl text-black uppercase tracking-[.25rem] xl:tracking-[.15rem] font-medium !-mt-10 relative z-20">
                            {{ product.title }}
                        </h2>
                        <p class="text-black text-xs sm:text-sm xl:text-xs !leading-relaxed md:max-w-[45ch]">
                            {{ product["description_" + lang] }}
                        </p>

                        <div v-if="['vini-bianchi', 'vini-rossi', 'rifermentati-e-spumanti'].includes(product.category)" class="flex flex-col gap-y-3 !mt-8">
                            <div v-if="product.detail_1 != ''" class="w-full flex flex-col">
                                <span class="text-primary text-sm sm:text-base xl:text-sm !leading-relaxed">
                                    {{$root.translateString('typology')}}
                                </span>
                                <span class="text-black text-xs sm:text-sm xl:text-xs !leading-relaxed">
                                    {{ product.detail_1 }}
                                </span>
                            </div>
                            <div v-if="product.detail_2 != ''" class="w-full flex flex-col">
                                <span class="text-primary text-sm sm:text-base xl:text-sm !leading-relaxed">
                                    {{$root.translateString('origin')}}
                                </span>
                                <span class="text-black text-xs sm:text-sm xl:text-xs !leading-relaxed">
                                    {{ product.detail_2 }}
                                </span>
                            </div>
                            <div v-if="product.detail_3 != ''" class="w-full flex flex-col">
                                <span class="text-primary text-sm sm:text-base xl:text-sm !leading-relaxed">
                                    {{$root.translateString('location')}}
                                </span>
                                <span class="text-black text-xs sm:text-sm xl:text-xs !leading-relaxed">
                                    {{ product.detail_3 }}
                                </span>
                            </div>
                        </div>

                        <div v-else-if="['grappe-invecchiate', 'grappe-bianche', 'grappe-alle-erbe'].includes(product.category)" class="flex flex-col gap-y-3 !mt-8">
                            <div v-if="product.detail_1 != ''" class="w-full flex flex-col">
                                <span class="text-primary text-sm sm:text-base xl:text-sm !leading-relaxed">
                                    {{$root.translateString('typology')}}
                                </span>
                                <span class="text-black text-xs sm:text-sm xl:text-xs !leading-relaxed">
                                    {{ product.detail_1 }}
                                </span>
                            </div>
                            <div v-if="product.detail_2 != ''" class="w-full flex flex-col">
                                <span class="text-primary text-sm sm:text-base xl:text-sm !leading-relaxed">
                                    {{$root.translateString('origin')}}
                                </span>
                                <span class="text-black text-xs sm:text-sm xl:text-xs !leading-relaxed">
                                    {{ product.detail_2 }}
                                </span>
                            </div>
                            <div v-if="product.detail_3 != ''" class="w-full flex flex-col">
                                <span class="text-primary text-sm sm:text-base xl:text-sm !leading-relaxed">
                                    {{$root.translateString('alcoholic-range')}}
                                </span>
                                <span class="text-black text-xs sm:text-sm xl:text-xs !leading-relaxed">
                                    {{ product.detail_3 }} °
                                </span>
                            </div>
                        </div>

                        <div v-else-if="['liquori-ed-amari', 'acquaviti-di-frutta'].includes(product.category)" class="flex flex-col gap-y-3 !mt-8">
                            <div v-if="product.detail_1 != ''" class="w-full flex flex-col">
                                <span class="text-primary text-sm sm:text-base xl:text-sm !leading-relaxed">
                                    {{$root.translateString('typology')}}
                                </span>
                                <span class="text-black text-xs sm:text-sm xl:text-xs !leading-relaxed">
                                    {{ product.detail_1 }}
                                </span>
                            </div>
                            <!-- <div class="w-full flex flex-col">
                                <span class="text-primary text-sm sm:text-base xl:text-sm !leading-relaxed">
                                    Vitigno
                                </span>
                                <span class="text-black text-xs sm:text-sm xl:text-xs !leading-relaxed">
                                    {{ product.detail_2 }}
                                </span>
                            </div> -->
                            <div v-if="product.detail_3 != ''" class="w-full flex flex-col">
                                <span class="text-primary text-sm sm:text-base xl:text-sm !leading-relaxed">
                                    {{$root.translateString('alcoholic-range')}}
                                </span>
                                <span class="text-black text-xs sm:text-sm xl:text-xs !leading-relaxed">
                                    {{ product.detail_3 }} °
                                </span>
                            </div>
                        </div>

                        <div v-else class="flex flex-col gap-y-3 !mt-8">
                            <div v-if="product.detail_1 != ''" class="w-full flex flex-col">
                                <span class="text-primary text-sm sm:text-base xl:text-sm !leading-relaxed">
                                    {{$root.translateString('typology')}}
                                </span>
                                <span class="text-black text-xs sm:text-sm xl:text-xs !leading-relaxed">
                                    {{ product.detail_1 }}
                                </span>
                            </div>
                            <div v-if="product.detail_2 != ''" class="w-full flex flex-col">
                                <span class="text-primary text-sm sm:text-base xl:text-sm !leading-relaxed">
                                    Formato
                                </span>
                                <span class="text-black text-xs sm:text-sm xl:text-xs !leading-relaxed">
                                    {{ product.detail_2 }} °
                                </span>
                            </div>
                            <div v-if="product.detail_3 != ''" class="w-full flex flex-col">
                                <span class="text-primary text-sm sm:text-base xl:text-sm !leading-relaxed">
                                    -
                                </span>
                                <span class="text-black text-xs sm:text-sm xl:text-xs !leading-relaxed">
                                    {{ product.detail_3 }} °
                                </span>
                            </div>
                        </div>

                        <div class="w-full !mt-14">
                            <a :href="'/materiale-scaricabile/' + product.slug + '/scheda-' + lang + '.pdf'" class="inline-flex flex-col gap-y-1 text-customGray-text xl:hover:text-black transition-all">
                                <span class="flex items-center gap-x-2.5">
                                    <span>
                                        <svg class="h-4.5 w-auto" xmlns="http://www.w3.org/2000/svg" width="16.204" height="18.825" viewBox="0 0 16.204 18.825">
                                            <g id="Raggruppa_6978" data-name="Raggruppa 6978" transform="translate(-5681.869 -6708.737)">
                                                <path id="Tracciato_7421" data-name="Tracciato 7421" d="M5697.573,6727.062h-15.2v-17.825h10.445l4.759,4.759Z" fill="none" stroke="currentColor" stroke-width="1" fill-rule="evenodd"/>
                                                <path id="Tracciato_7422" data-name="Tracciato 7422" d="M5692.814,6709.621V6714h4.451" fill="none" stroke="currentColor" stroke-width="1"/>
                                                <g id="Raggruppa_6977" data-name="Raggruppa 6977">
                                                <line id="Linea_118" data-name="Linea 118" x1="7.75" transform="translate(5684.85 6717.528)" fill="none" stroke="currentColor" stroke-width="1"/>
                                                <line id="Linea_119" data-name="Linea 119" x1="7.75" transform="translate(5684.85 6720.317)" fill="none" stroke="currentColor" stroke-width="1"/>
                                                <line id="Linea_120" data-name="Linea 120" x1="1.516" transform="translate(5693.576 6717.528)" fill="none" stroke="currentColor" stroke-width="1"/>
                                                <line id="Linea_121" data-name="Linea 121" x1="1.516" transform="translate(5693.576 6720.317)" fill="none" stroke="currentColor" stroke-width="1"/>
                                                <line id="Linea_122" data-name="Linea 122" x1="1.516" transform="translate(5693.576 6723.106)" fill="none" stroke="currentColor" stroke-width="1"/>
                                                <line id="Linea_123" data-name="Linea 123" x1="7.75" transform="translate(5684.85 6723.106)" fill="none" stroke="currentColor" stroke-width="1"/>
                                                </g>
                                            </g>
                                            </svg>
                                    </span>
                                    <span class="text-xs sm:text-sm xl:text-xs block uppercase tracking-[.11rem] font-medium pt-0.5">
                                        {{$root.translateString('tech-sheet')}}
                                    </span>
                                </span>
                                <span class="w-full flex justify-center pl-0.5">
                                    <svg class="h-2.25 w-auto" xmlns="http://www.w3.org/2000/svg" width="99.835" height="9.74" viewBox="0 0 99.835 9.74">
                                        <g id="Raggruppa_11096" data-name="Raggruppa 11096" transform="translate(-428.615 -3027.908)">
                                        <g id="Raggruppa_11095" data-name="Raggruppa 11095">
                                            <g id="Raggruppa_11094" data-name="Raggruppa 11094">
                                            <path id="Tracciato_12805" data-name="Tracciato 12805" d="M527.919,3030.5c-11.266.7-9.685,1.133-17.555,1.954s-13.587-.9-21.383-1.643c-3.092-.293-11.261-1.42-19.737.129a60.767,60.767,0,0,0-16.306,5.168c-3.033,1.791,6.242,1.559,7.86-3.13a2.677,2.677,0,0,0-.723-3.031c-4.28-2.947-16.6,2.361-20.776,4.033-5.17,2.067.091-2.442,1.044-4.189s-7.856,5.015-9.864,3.652c-2.214-1.5-.811-4.878-.811-4.878" fill="none" stroke="#c1a062" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                                            </g>
                                        </g>
                                        </g>
                                    </svg>
                                </span>
                            </a>
                        </div>
                        <div class="w-full !mt-8">
                            <a :href="product['url_' + lang] + product.slug" class="relative w-full lg:w-auto px-20 lg:px-26 py-4.5 inline-flex items-center bg-customGray-background transition-all !duration-500 lg:mb-20 xl:hover:!rounded-lg group">
                                <span class="absolute w-full h-[calc(100%+1rem)] left-0 top-1/2 -translate-y-1/2 border border-customGray-border/80 rounded-lg pointer-events-none group-hover:h-full group-hover:w-full transition-all !duration-[400ms]"></span>
                                <span class="absolute h-full w-[calc(100%+1rem)] top-0 left-1/2 -translate-x-1/2 border border-customGray-border/80 rounded-lg pointer-events-none group-hover:h-full group-hover:w-full transition-all !duration-[400ms] group-hover:xl:opacity-0"></span>
                                <span class="text-black text-xs sm:text-sm xl:text-xs block w-full text-center uppercase tracking-[.11rem] font-medium">
                                    {{$root.translateString('go_to_shop')}}
                                </span>
                            </a>
                        </div>
                    </div>
                </div>

            </div>

        </div>

    </div>

</template>

<script>
    export default {
        props: ['content', 'lang'],
        data() {
            return {
                show: false,
                product: null
            }
        },
        mounted() {

            window.addEventListener('showProductPopup', (event) => {

                let slug = event.detail[0]
                let category = event.detail[1]

               // console.log(category)

                this.content[category].forEach(el => {
                    if(el.slug == slug) {
                        this.product = el
                    }
                })

                setTimeout(() => {
                    this.show = true;
                })


            }, false)

        },

        methods: {
            closeSidePopup() {
                this.show = false;
                const event = new CustomEvent('closeProductPopup', {});
                dispatchEvent(event)
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>
